import { useCallback, useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from 'src/components/Button';
import './style.scoped.css';
import { useHistory } from 'react-router-dom';
import { confirmQuitFlow } from 'src/utils';
import feeStore, { FeeStore } from 'src/stores/FeeStore';
import { observer } from 'mobx-react-lite';

interface FeeConfirmObserverProps {
  feeStore?: FeeStore;
}
const FeeConfirmObserver = observer(({ feeStore }: FeeConfirmObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const _handlePay = () => {
    feeStore.createInquiryHsycbh();
  };

  const _handleClose = () => {
    confirmQuitFlow(history, t('confirm_quit_pay_fee'));
  };

  return (
    <div className="screen-container bg-background">
      <Toolbar
        title={t('pay_fee_ycbh')}
        type="normal"
        showClose={true}
        onClose={_handleClose}
      />
      <div className="max-w-md mx-auto screenScrollContainer">
        <div className="h-4" />
        <div className="cardItemNoPadding">
          <div className="blockTitle blockTitleContainer">
            {t('document_info')}
          </div>
          <div className="px-4 pb-6 pt-6">
            <div className="flex flex-row pb-4">
              <div className="flex-1 bodyText2 text-onSurfaceVariant">
                {t('ycbh_number2')}
              </div>
              <div className="smallTitle2">{feeStore?.feeInfo?.applNo}</div>
            </div>
            <div className="flex flex-row pb-4">
              <div className="flex-1 bodyText2 text-onSurfaceVariant">
                {t('insurance_buyer')}
              </div>
              <div className="smallTitle2">{feeStore?.feeInfo?.holderName}</div>
            </div>
            <div className="flex flex-row pb-4">
              <div className="flex-1 bodyText2 text-onSurfaceVariant">
                {t('insurancer')}
              </div>
              <div className="smallTitle2">
                {feeStore?.feeInfo?.insuredName}
              </div>
            </div>
            <div className="flex flex-row">
              <div className="flex-1 bodyText2 text-onSurfaceVariant">
                {t('product')}
              </div>
              <div className="smallTitle2">
                {feeStore?.feeInfo?.productName}
              </div>
            </div>
          </div>
        </div>
        <div className="h-4" />
        <div className="cardItemNoPadding">
          <div className="blockTitle blockTitleContainer">
            {t('insurance_fee_pay')}
          </div>
          <div className="px-4 pb-6 pt-6">
            <div
              className={`flex flex-row pb-4 ${
                feeStore?.feeInfo?.topUp ? '' : 'border-b border-line'
              }`}
            >
              <div className={'flex-1 bodyText2 text-onSurfaceVariant'}>
                {t('provisional_first_time_fee')}
              </div>
              <div className="smallTitle2">
                {feeStore?.feeInfo?.premAfterTax}
              </div>
            </div>
            {feeStore?.feeInfo?.topUp && (
              <div className="flex flex-row pb-4 border-b border-line">
                <div className="flex-1 bodyText2 text-onSurfaceVariant">
                  {t('additional_insurance_fee')}
                </div>
                <div className="smallTitle2">{feeStore?.feeInfo?.topUp}</div>
              </div>
            )}
            <div className="flex flex-row pt-5">
              <div className="flex-1 bodyText2 text-onSurface">
                {t('total_fee')}
              </div>
              <div className="blockTitlePrimary">
                {feeStore?.feeInfo?.totalPayment}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bottomButtonBlock">
        <div className="flex flex-row">
          <Button
            text={t('payment')}
            buttonType={ButtonTypes.primaryFilled}
            extraClassName="w-full"
            onClick={_handlePay}
          />
        </div>
      </div>
    </div>
  );
});

const FeeConfirm = () => <FeeConfirmObserver feeStore={feeStore} />;
export default FeeConfirm;
